<template>
    <div>
        <div v-for="(v, k) in options" :key="k" class="col-12 col-sm-6">
            <div class="input-container e-radio-container no-min-h mb-4 TipologiaClienteSelezionata parsley-success">
                <input @click="onClick(v)" v-model="internalValue" :value="v" type="radio" class="e-radio" name="TipologiaClienteSelezionata" required> 
                <label @click="onClick(v)" data-bind="text:label">{{v}}</label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: Array,
        value: String
    },
    computed: {
        internalValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val)
            }
        }
    },
    data(){
        return {
            
        }
    },
    methods:{
        onClick(v){
            this.internalValue = v
        }
    }
}
</script>

<style>

</style>
